import anotheraxiosinstance from 'axios';

// import router from '@/router';

// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const genericapi = anotheraxiosinstance.create({

});

genericapi.defaults.baseURL = process.env.VUE_APP_RAM_GENERIC_API_URL;
genericapi.defaults.headers.post['Content-Type'] = 'application/json';

genericapi.interceptors.response.use((response: any) => {
    return response;
}, (error: any) => {
    if (typeof error.response !== 'undefined' && error.response.status === 401) {
        // store.commit('auth/setToken', '');
        // store.commit('auth/setUsername', '');
        // store.commit('auth/setName', '');
        // store.commit('auth/setRole', '');

        genericapi.defaults.headers.common.Authorization = '';

        // router.push({
        //     name: 'Login',
        //     params: {
        //         error: 'Your session has expired. Please login.',
        //     },
        // });
    }

    throw error;
});




// export {genericapiinstance,axios};
export default genericapi;

